import classNames from 'classnames';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJAiVideoDubRightDefaultContainer from '../container/FJAiVideoDubRightDefaultContainer';
import styles from './FJAiVideoDubRight.module.less';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJAiVideoDubRightStatusBoxContainer from '../container/FJAiVideoDubRightStatusBoxContainer';
import PropTypes from 'prop-types';
import FJConstant from '../../../../constants/FJConstant';
import FJAiVideoDubRightSuccessContainer from '../container/FJAiVideoDubRightSuccessContainer';

const FJAiVideoDubRight = ({ taskStatus, hasResult }) => {
    return (
        <FJDragBox className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer />
            <FJAiVideoDubRightDefaultContainer isShow={!hasResult && taskStatus === FJConstant.DEFAULT} />
            <FJAiVideoDubRightStatusBoxContainer
                isShow={taskStatus !== FJConstant.DEFAULT && taskStatus !== FJConstant.SUCCESS}
            />
            <FJAiVideoDubRightSuccessContainer
                isShow={hasResult && (taskStatus === FJConstant.SUCCESS || taskStatus === FJConstant.DEFAULT)}
            />
            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
};

FJAiVideoDubRight.propTypes = {
    taskStatus: PropTypes.string.isRequired,
    hasResult: PropTypes.bool.isRequired,
};

export default FJAiVideoDubRight;
